import React, {useState} from 'react'
import {connect} from "react-redux";
import {useForm} from "react-hook-form";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";

// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";
import SelectGeneric from "../../../components/select/selectGeneric";

// actions
import {setFilter} from "../../../redux/actions/generalActions/listActions";

// labels
import {FL_CLASS_NAME, FL_CODE, FL_DATA_BASE} from "../../../components/i18n/formLabels";
import {PH_CLASS_NAME, PH_CODE,} from "../../../components/i18n/placeHolders";
import {LB_GALLERY, LB_LANG, LB_SAME_IMG_LANGS, LB_THUMB} from "../../../components/i18n/i18n";

// providers
import {fbDatabaseProvider} from "../../../providers/fbDatabaseProvider";
import {mainProvider} from "../../../providers/mainProvider";


const FbMediaConfigFilter = props => {
    const { filter } = props.listProps

    const [fbDataBaseId, setFbDataBaseId] = useState(filter?.fbDataBase?.id || null);
    const [className, setClassName] = useState(filter?.className || null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            fieldCode: filter?.fieldCode || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            ...data,
            className : className
        };

        if(fbDataBaseId)
            dataFilter.fbDataBase = {id: fbDataBaseId }

        props.setFilter(dataFilter);
    };

    const cleanFields = () => {
        setFbDataBaseId(null)
        setClassName(null)
        reset({
            fieldCode: ''
        });

        props.setFilter({
            item : {
                fieldCode   : null,
            }
        });
    }

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{ FL_DATA_BASE }</Label>
                        <br/>
                        <SelectGeneric
                            initialValue={ fbDataBaseId }
                            setExternalValue={ setFbDataBaseId }
                            provider={ fbDatabaseProvider }
                        />
                    </FormGroup>
                </Col>
                <Col  md="4">
                    <FormGroup>
                        <Label>{ 'Paquete . Clase' }</Label>
                        <SelectGeneric
                            initialValue={ className }
                            setExternalValue={ setClassName }
                            provider={ mainProvider }
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{ FL_CODE }</Label>
                        <Input type="text"
                               name="fieldCode"
                               placeholder={ PH_CODE }
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={cleanFields}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(FbMediaConfigFilter)